import { Record } from 'immutable';

export default class CreditLine extends Record({
  amount: 0,
  remaining_amount: 0,
}) {}
